import roles from "helpers/roles";

const SETTINGS_EDIT_ACCESS = ["F", "E"];

// Mirrors the backend's [AuthorizeMulti("Settings Edit,IsAdmin,IsReseller,IsClientAdmin")]
// on the site locale-settings endpoints.
export const canEditLanguageSettings = (role, position) =>
	role === roles.superAdmin ||
	role === roles.clientAdmin ||
	SETTINGS_EDIT_ACCESS.includes(position?.settingsAccess);
